// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
    "dirty": false,
    "raw": "0bd04f9",
    "hash": "0bd04f9",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "0bd04f9",
    "semverString": null,
    "version": "1.4.0"
};
